import { Request } from '../request';
import { IGetDocumentListParams, ISaveOrUpdateDocument } from 'types/document';

export const getDocumentList = (params: IGetDocumentListParams) => Request.post({ url: '/schedule-server/document/page', params });

export const uploadDocument = (params: { file: File, clientId: string }) => Request.post({
    url: '/schedule-server/document/upload/for/client',
    params,
    config: {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    },
});

export const saveOrUpdateDocument = (params: ISaveOrUpdateDocument[], clientId: string) => Request.post({ url: `/schedule-server/document/saveOrUpdate/${clientId}`, params });

export const markDocumentAsSeen = (documentId: string, versionId: string) => Request.post({ url: `/schedule-server/document/version/seen/${documentId}/${versionId}` });

export const getDocumentFilters = () => Request.get({ url: '/schedule-server/document/filters' });